import {useParams} from 'react-router-dom';

import {ModuleEnum, PermissionOperationEnum} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';

import {CourseVideoForm} from 'src/app/course-video/CourseVideoForm';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

const EditCourseVideoPage = () => {
  const {courseVideoId} = useParams();

  return (
    <ContentWrapper>
      <CourseVideoForm id={+courseVideoId!} mode="edit" view="content" />
    </ContentWrapper>
  );
};

routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.CourseVideoEdit(':courseVideoId'),
  element: <EditCourseVideoPage />,
  module: ModuleEnum.Training,
  operation: PermissionOperationEnum.Update,
  isPrivate: true,
});

export default EditCourseVideoPage;
